import React, { useEffect, useState } from 'react'
import AdsNavbar from '../AdsNavbar'
import Loader from '../../../../components/Loader'
import Calling from '../../../../api/Calling';
import { toast } from 'react-toastify';
import NotFound from '../../../../components/ul/NotFound';
import { useNavigate } from 'react-router-dom';
import MainButton from '../../../../components/ul/MainButton';
import { formatView } from '../../../../components/formatView';
import generateCaptcha from '../../../../components/captcha';
import { MdDeleteOutline } from 'react-icons/md';
import DeleteButton from '../../../../components/ul/DeleteButton'
import TopNavbar from '../../TopNavbar';

const IosWebAds = () => {
    const [loader, setLoader] = useState(false);
    const [nativeAds, setNativeAds] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [showAddForm, setShowAddForm] = useState(false);
    const [newAd, setNewAd] = useState({ a_name: '', a_id: '', a_description: '' });
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
    const [selectState, setSelectState] = useState('today');
    const navigate = useNavigate();


    const fetchData = async () => {
        setLoader(true);
        try {
            const prevData = JSON.parse(localStorage.getItem('web_clicks_ios')) || [];
            const resp = await Calling.getIosWebAds(startDate, endDate);
            if (resp?.status) {
                const updatedData = resp.data.map((item) => {
                    const prevItem = prevData.find((i) => i._id === item._id);
                    const prevClick = prevItem ? prevItem.a_click : 0;
                    const diff = item.a_click - prevClick;

                    return { ...item, diff };
                });

                // Store current data to localStorage for next refresh
                localStorage.setItem('web_clicks_ios', JSON.stringify(resp.data));
                setNativeAds(updatedData);
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, [startDate, endDate]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    }
    const handleClick = (id, name) => {
        navigate(`/views/dashboard/${id}?q=${name}&adsType=web`);
    };

    const handleDateRangeFilter = (range) => {
        const today = new Date();
        let start, end;

        switch (range) {
            case 'today':
                start = today.toISOString().split('T')[0];
                end = start;
                setSelectState('today');
                break;
            case 'yesterday':
                const yesterday = new Date();
                yesterday.setDate(today.getDate() - 1);
                start = yesterday.toISOString().split('T')[0];
                end = start;
                setSelectState('yesterday');
                break;
            case 'thisWeek':
                const firstDayOfWeek = new Date(today.setDate(today.getDate() - today.getDay()));
                const lastDayOfWeek = new Date(firstDayOfWeek);
                lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
                start = firstDayOfWeek.toISOString().split('T')[0];
                end = lastDayOfWeek.toISOString().split('T')[0];
                setSelectState('thisWeek');
                break;
            case 'thisMonth':
                start = new Date(today.getFullYear(), today.getMonth(), 1)
                    .toISOString()
                    .split('T')[0];
                end = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                    .toISOString()
                    .split('T')[0];
                setSelectState('thisMonth');
                break;
            case 'last6Months':
                start = new Date(today.getFullYear(), today.getMonth() - 5, 1)
                    .toISOString()
                    .split('T')[0];
                end = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                    .toISOString()
                    .split('T')[0];
                setSelectState('last6Months');
                break;
            case 'thisYear':
                start = new Date(today.getFullYear(), 0, 1).toISOString().split('T')[0];
                end = new Date(today.getFullYear(), 11, 31).toISOString().split('T')[0];
                setSelectState('thisYear');
                break;
            default:
                start = '';
                end = '';
        }

        setStartDate(start);
        setEndDate(end);
    };

    const filteredAds = nativeAds.filter(ad =>
        ad.a_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ad.a_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ad.a_description.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleEdit = (id) => {
        setEditingId(id);
    }

    const handleSave = async (id) => {
        const adToUpdate = nativeAds.find(ad => ad._id === id);
        setLoader(true)

        try {
            const resp = await Calling.updateIosWebAds(id, {
                a_id: adToUpdate.a_id,
                a_description: adToUpdate?.a_description
            });
            if (resp?.status) {
                toast.success(resp?.message);
                fetchData();
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
            setEditingId(null);
        }
    }

    const handleInputChange = (id, field, value) => {
        setNativeAds(nativeAds.map(item =>
            item._id === id ? { ...item, [field]: value } : item
        ));
    }

    const handleAddSubmit = async () => {
        if (newAd.a_name.trim() === '' || newAd.a_id.trim() === '' || newAd.a_description.trim() === '') {
            toast.error('Please fill all the fields');
            return;
        }

        setLoader(true);
        try {
            const body = {
                a_name: newAd.a_name.replace(/ /g, ''),
                a_id: newAd.a_id.replace(/ /g, ''),
                a_description: newAd.a_description
            }
            const resp = await Calling.addIosWebAds(body);
            if (resp?.status) {
                toast.success(resp?.message);
                setNewAd({ a_name: '', a_id: '', a_description: '' });
                setShowAddForm(false);
                fetchData();
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    }

    const handleFormDate = (e) => {
        if (e.target.name === "startDate") {
            setStartDate(e.target.value);
            setSelectState('range');
        } else {
            setEndDate(e.target.value);
            setSelectState('range');
        }
    }

    const clearData = async () => {
        const content = `You are about to clear data. To confirm, please solve this math problem.`;
        const isCaptchaValid = generateCaptcha(content);

        if (!isCaptchaValid) {
            return toast.error('Captcha answer is not correct', { autoClose: 2000 });
        }

        setLoader(true);
        try {
            let id = [];
            if (nativeAds.length > 0) {
                id = nativeAds.map(item => item._id);
            } else {
                return toast.error('Ads Not Availale');
            }

            const body = {
                id
            }
            const response = await Calling.allIosdeleteWebClear(body, startDate, endDate);

            if (response?.status) {
                toast.success(response?.message);
            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoader(false);
            fetchData();
        }
    };
    const deleteWebData = async (id) => {
        const content = `You are about to clear data. To confirm, please solve this math problem.`;
        const isCaptchaValid = generateCaptcha(content);

        if (!isCaptchaValid) {
            return toast.error('Captcha answer is not correct', { autoClose: 2000 });
        }
        setLoader(true);
        try {
            const response = await Calling.deleteIosWeb(id);
            if (response?.status) {
                toast.success(response?.message);
            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoader(false);
            fetchData();
        }
    };
    return (
        <>
            {loader ? (
                <Loader loader={loader} />
            ) : (
                <div className='w-full text-main-font md:mt-20 mt-16 px-2 md:px-3 md:ml-[4.4rem]'>
                    <h1 className="text-xl sm:text-2xl font-bold mt-4 text-main-font w-auto">Ad Management</h1>
                    <div className='bg-main-white rounded-xl shadow-sm'>
                        <TopNavbar selectState={'ios'} />
                        <hr className='mt-2 bg-main-border border-[1px]' />
                        <AdsNavbar selectState={'webAds'} />
                        <hr className='mt-2 bg-main-border border-[1px]' />

                        <div className='px-4 sm:px-6 pt-4 sm:pt-6'>
                            <div className='flex flex-col sm:flex-row justify-between items-center mb-4 sm:mb-5'>
                                <h1 className='text-lg sm:text-2xl font-bold text-main-font mb-2 sm:mb-0'>Web Ads (Apple ios)</h1>
                                <button
                                    onClick={() => setShowAddForm(!showAddForm)}
                                    className='px-3 py-2 text-sm sm:text-md text-main-white bg-green-600 rounded-3xl hover:bg-green-700'
                                >
                                    + Add Web Ads
                                </button>
                            </div>
                            <hr className='border-main-border' />

                            {showAddForm && (
                                <div className="mt-4 sm:mt-6 p-3 sm:p-4 rounded-lg space-y-4 bg-main-bg">
                                    <div className='grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4'>
                                        <div className='flex flex-col sm:flex-row items-center'>
                                            <label className='w-full sm:w-1/4 text-sm sm:text-base text-main-font font-medium mb-2 sm:mb-0'>Ad Name:</label>
                                            <input
                                                type="text"
                                                placeholder="Ad Name"
                                                value={newAd.a_name}
                                                onChange={(e) => setNewAd({ ...newAd, a_name: e.target.value })}
                                                className='w-full p-2 border border-main-border rounded text-sm focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                            />
                                        </div>
                                        <div className='flex flex-col sm:flex-row items-center'>
                                            <label className='w-full sm:w-1/4 text-sm sm:text-base text-main-font font-medium mb-2 sm:mb-0'>Ad URL:</label>
                                            <input
                                                type="text"
                                                placeholder="Ad URL"
                                                value={newAd.a_id}
                                                onChange={(e) => setNewAd({ ...newAd, a_id: e.target.value })}
                                                className='w-full p-2 border border-main-border rounded text-sm focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                            />
                                        </div>
                                    </div>

                                    <div className='grid grid-cols-1 gap-2'>
                                        <label className='text-sm sm:text-base text-main-font font-medium'>Description:</label>
                                        <textarea
                                            type="text"
                                            placeholder="Ad Description"
                                            value={newAd?.a_description}
                                            onChange={(e) => setNewAd({ ...newAd, a_description: e.target.value })}
                                            className='w-full p-2 border border-main-border rounded text-sm focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                        />
                                    </div>

                                    <div className='flex justify-start'>
                                        <div className="flex gap-3 sm:gap-4 py-2">
                                            <button
                                                onClick={handleAddSubmit}
                                                className="px-3 py-1 text-sm sm:text-md text-main-white bg-main-blue rounded hover:bg-main-blue/80 transition"
                                            >
                                                Submit
                                            </button>
                                            <button
                                                onClick={() => setShowAddForm(false)}
                                                className="px-3 py-1 text-sm sm:text-md text-main-delete border border-main-delete bg-main-white rounded hover:bg-main-delete/10 transition"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="flex flex-col space-y-4 sm:space-y-0 mt-6 sm:flex-row sm:justify-between w-full">
                                {/* Date range buttons */}
                                <div className='grid grid-cols-2 sm:flex sm:flex-wrap gap-2'>
                                    <MainButton onClick={() => handleDateRangeFilter('today')} label={'Today'} selectState={selectState === ('today')} />
                                    <MainButton onClick={() => handleDateRangeFilter('yesterday')} label={'Yesterday'} selectState={selectState === "yesterday"} />
                                    <MainButton onClick={() => handleDateRangeFilter('thisWeek')} label={'This Week'} selectState={selectState === ('thisWeek')} />
                                    <MainButton onClick={() => handleDateRangeFilter('thisMonth')} label={'This Month'} selectState={selectState === ('thisMonth')} />
                                    <MainButton onClick={() => handleDateRangeFilter('last6Months')} label={'Last 6 Months'} selectState={selectState === ('last6Months')} />
                                    <MainButton onClick={() => handleDateRangeFilter('thisYear')} label={'This Year'} selectState={selectState === ('thisYear')} />
                                </div>

                                {/* Date pickers */}
                                <div className="flex flex-col sm:flex-row gap-2 mt-4 sm:mt-0">
                                    <input
                                        type="date"
                                        value={startDate}
                                        name='startDate'
                                        onChange={handleFormDate}
                                        className={`border cursor-pointer bg-main-white ${selectState === "range"
                                            ? 'border-main-blue text-main-blue'
                                            : 'border-main-border text-main-subfont'
                                            } px-2 sm:px-4 py-2 rounded-lg focus:border-main-blue shadow-sm w-full  h-min`}
                                    />
                                    <input
                                        type="date"
                                        value={endDate}
                                        name='endDate'
                                        onChange={handleFormDate}
                                        className={`border cursor-pointer bg-main-white ${selectState === "range"
                                            ? 'border-main-blue text-main-blue'
                                            : 'border-main-border text-main-subfont'
                                            } px-2 sm:px-4 py-2 rounded-lg focus:border-main-blue shadow-sm w-full  h-min`}
                                    />
                                    <div className="flex flex-col cursor-pointer">
                                        {nativeAds.length > 0 && (
                                            <div className='flex  justify-end'>
                                                <MainButton onClick={clearData} className='bg-main-delete text-white' label={<MdDeleteOutline />} />
                                            </div>)
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="overflow-x-auto py-4 sm:py-6">
                            {/* Search Bar */}
                            <div className="mb-4 sm:mb-6 px-4 sm:px-6">
                                <input
                                    type="text"
                                    placeholder="Search Ads..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    className="p-2 border rounded-lg w-full text-sm"
                                />
                            </div>

                            <div className='overflow-x-auto'>
                                <table className='w-full min-w-[800px]'>
                                    <thead className='bg-main-th text-main-font uppercase'>
                                        <tr>
                                            <th className="text-left px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium rounded-tl-lg">No</th>
                                            <th className="text-left px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium">Ad Name</th>
                                            <th className="text-left px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium">Ad URL</th>
                                            <th className="text-left px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium">Ad Description</th>
                                            <th className="text-left px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium">Click</th>
                                            <th className="text-center px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium rounded-tr-lg">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredAds.length > 0 ?
                                            filteredAds?.map((item, index) => (
                                                <tr key={index} className="hover:bg-main-thHover">
                                                    <td className="px-3 sm:px-4 py-2 text-xs sm:text-sm text-main-font">{index + 1}</td>
                                                    <td className="px-3 sm:px-4 py-2 text-xs sm:text-sm text-main-font">{item.a_name}</td>
                                                    <td className="px-3 sm:px-4 py-2 text-xs sm:text-sm text-main-font">
                                                        {editingId === item._id ? (
                                                            <input
                                                                type="text"
                                                                value={item.a_id}
                                                                onChange={(e) => handleInputChange(item._id, 'a_id', e.target.value)}
                                                                className="p-2 w-full border border-main-border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-xs sm:text-sm"
                                                            />
                                                        ) : (
                                                            <span className="text-xs sm:text-sm text-main-font break-all">{item.a_id}</span>
                                                        )}
                                                    </td>
                                                    <td className="px-3 sm:px-4 py-2 text-xs sm:text-sm">
                                                        {editingId === item._id ? (
                                                            <textarea
                                                                type="text"
                                                                value={item.a_description}
                                                                onChange={(e) => handleInputChange(item._id, 'a_description', e.target.value)}
                                                                className="p-2 w-full border border-main-border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-xs sm:text-sm"
                                                            />
                                                        ) : (
                                                            <span className="text-xs sm:text-sm text-main-font break-all">{item.a_description}</span>
                                                        )}
                                                    </td>
                                                    <td className="px-3 sm:px-4 py-2 text-xs sm:text-sm">
                                                        {
                                                            <MainButton
                                                                label={
                                                                    <>
                                                                        {item?.a_click < 10
                                                                            ? '0' + item?.a_click
                                                                            : formatView(item?.a_click)}
                                                                    </>
                                                                }
                                                                onClick={() => handleClick(item._id, item.a_name)}
                                                            />

                                                        }
                                                        {item?.diff > 0 && (
                                                            <span className="text-green-600 text-sm font-medium ml-1">
                                                                (+{item.diff})
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="text-center px-3 sm:px-4 py-2">
                                                        <div className="flex justify-center gap-2">
                                                            <button
                                                                onClick={() => editingId === item._id ? handleSave(item._id) : handleEdit(item._id)}
                                                                className={`px-3 sm:px-4 py-1 text-xs sm:text-sm text-main-white rounded transition-colors ${editingId === item._id
                                                                    ? 'bg-green-500 hover:bg-green-600 active:bg-green-700'
                                                                    : 'bg-main-blue hover:bg-main-blue/80 active:bg-main-blue/70'
                                                                    }`}
                                                            >
                                                                {editingId === item._id ? 'Save' : 'Edit'}
                                                            </button>
                                                            {editingId === item._id && (
                                                                <>
                                                                    <button
                                                                        onClick={() => setEditingId(null)}
                                                                        className="px-3 sm:px-4 py-1 text-xs sm:text-sm font-medium text-main-white bg-red-500 hover:bg-red-600 active:bg-red-700 rounded transition-colors"
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                    {item.a_name !== 'WEB_URL_1' ? <DeleteButton onClick={() => deleteWebData(item._id)} /> : ''}
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                            :
                                            <tr><td className='text-center' colSpan={5}><NotFound /></td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default IosWebAds